// This module provides definitions for generic shape objects

// TODO: Optimizations
// 1. While Point and Size are semantically different things, logically they're very similar
// 2. The APIs for these objects are not consistently implemented:
//    a. Inconsistent type checking
//    b. Inconsistent return values
//    c. Inconsistent naming conventions
// 3. According to Cindy BoundingBox should derive from Rectangle. I'm not sure how they're actually different.

export {Point} from './Point';
export {Size} from './Size';
export {Rectangle} from './Rectangle';
export {BoundingBox} from './BoundingBox';



// WEBPACK FOOTER //
// ./src/uScope/js/lib/objects/index.js